var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    width: 16,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.75 7v13c0 .729-.29 1.429-.805 1.945-.516.515-1.216.805-1.945.805h-9c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-13c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h9c.729 0 1.429.29 1.945.805.515.516.805 1.216.805 1.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.75 18c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-13c0-1.243-1.007-2.25-2.25-2.25h-9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9c2.071 0 3.75 1.679 3.75 3.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b83146032d0318c33af9d9c763b4eec4.svg";
export { ForwardRef as ReactComponent };